import React, { Suspense, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import Header from '../components/Header'
import Polling from '../components/Header/Polling'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import ComingSoon from './ComingSoon'
import NoService from './NoService'
import { fetchLocation } from '../utils/option/location'
import { RedirectPathToSwapOnly } from './SpotIndex/redirects'
import SpotIndex from './SpotIndex'
import GovernanceDetail from './NFTGovernance/NFTGovernanceDetail'
import Locker from './Locker'
import CardDetail from './CardDetail'
import LockerDetail from './LockerDetail'
import UserLogin from '../pages/User/Login'
import User from './User'
import Box from './Box'
import WarningModal from 'components/Modal/WarningModal'
import Spinner from 'components/Spinner'

const AppWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.bg2};
  min-height: 100vh;
  min-width: ${({ theme }) => theme.minContentWidth};
  ${({ theme }) => theme.mediaWidth.upToSmall`
  flex-direction: column;
  height: 100vh;
  `};
`
const ContentWrapper = styled.div`
  width: 100%;
  max-height: 100vh;
  overflow: auto;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.headerHeight};
  ${({ theme }) => theme.mediaWidth.upToLarge`
    overflow-x:hidden;
  `}
`

const HeaderWrapper = styled.div`
  width: 100%;
  z-index: 10;
  justify-content: space-between;
  flex-direction: column;
  ${({ theme }) => theme.flexRowNoWrap};
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100vh - ${({ theme }) => theme.mobileHeaderHeight});
  justify-content: center;
  align-items: center;
  flex: 1;
  position: relative;
  ${({ theme }) => theme.mediaWidth.upToLarge`
  margin-bottom: ${({ theme }) => theme.headerHeight};
  min-height: calc(100vh - ${({ theme }) => theme.headerHeight + ' - ' + theme.mobileHeaderHeight});
  `}
`

export const Marginer = styled.div`
  ${({ theme }) => theme.desktop};
`

const resource = fetchLocation()

export default function App() {
  useEffect(() => {
    const el = document.querySelector('.loader-container')
    if (el) {
      el.remove()
    }
  }, [])
  return (
    <Suspense fallback={null}>
      <Route component={UserLogin} />
      <AppWrapper id="app">
        <ContentWrapper>
          <HeaderWrapper id="header">
            <Header />
          </HeaderWrapper>
          <BodyWrapper id="body">
            <Popups />
            <Polling />
            <WarningModal />
            <Web3ReactManager>
              <LocatoinVerification resource={resource}>
                <Switch>
                  <Route exact strict path="/" component={SpotIndex} />
                  <Route exact strict path="/spot_index" component={SpotIndex} />
                  <Route exact strict path="/spot_detail/:nftid" component={CardDetail} />
                  <Route exact strict path="/collectables" component={Box} />
                  <Route exact strict path="/locker" component={Locker} />
                  <Route exact strict path="/locker/:nftid" component={LockerDetail} />
                  {/* <Route exact strict path="/governance" component={Governance} /> */}
                  <Route exact strict path="/governance" component={ComingSoon} />
                  <Route exact strict path="/governance/:governanceIndex" component={GovernanceDetail} />
                  <Route strict path="/profile/:tab" component={User} />
                  <Route strict path="/profile" component={User} />
                  <Route component={RedirectPathToSwapOnly} />
                </Switch>
              </LocatoinVerification>
            </Web3ReactManager>
          </BodyWrapper>
        </ContentWrapper>
      </AppWrapper>
    </Suspense>
  )
}

const isDev = process.env.NODE_ENV === 'development'
function LocatoinVerification({ resource, children }: { resource: { read(): any }; children: React.ReactNode }) {
  const location = resource.read()

  return (
    <Suspense fallback={<Spinner size={100} />}>
      {!isDev && (location === 'US' || location === 'CN' || !location) && false ? <NoService /> : children}
      {/*{location === 'US' || location === 'CN' || !location || location === 'Not found' ? children : children}*/}
    </Suspense>
  )
}
